export const PREFIX = "daily-login-streak";
